import Keycloak from 'keycloak-js';

export const keycloak = new Keycloak({
  url: process.env.VUE_APP_KEYCLOAK_URL,
  realm: process.env.VUE_APP_KEYCLOAK_REALM,
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
});

/**
 * Stable redirect URI for Keycloak (no hash or OAuth query params).
 * KC26 adds iss/code to the fragment; using window.location.href as redirect_uri
 * causes those params to accumulate on each login attempt.
 */
export function getKeycloakRedirectUri() {
  return `${window.location.origin}${window.location.pathname}`;
}

export function getKeycloakLogoutRedirectUri() {
  if (process.env.VUE_APP_KEYCLOAK_REDIRECT_URI) {
    return process.env.VUE_APP_KEYCLOAK_REDIRECT_URI;
  }

  return `${window.location.origin}/`;
}

const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirect';

export function savePostLoginPath() {
  if (!window.location.search) {
    return;
  }

  sessionStorage.setItem(
    POST_LOGIN_REDIRECT_KEY,
    `${window.location.pathname}${window.location.search}`,
  );
}

export function consumePostLoginPath() {
  const stored = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);

  if (stored) {
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  }

  return stored;
}

export function restorePostLoginPath() {
  const stored = consumePostLoginPath();

  if (!stored) {
    return;
  }

  const current = `${window.location.pathname}${window.location.search}`;

  if (stored !== current) {
    window.history.replaceState(window.history.state, document.title, stored);
  }
}

const KEYCLOAK_CALLBACK_HASH_PATTERN = /(^#|[&?])(code|state|session_state|iss)=/;

export function hasKeycloakCallbackHash(hash = window.location.hash) {
  return KEYCLOAK_CALLBACK_HASH_PATTERN.test(hash || '');
}

export function clearKeycloakCallbackHash() {
  if (!hasKeycloakCallbackHash()) {
    return;
  }

  const cleanUrl = `${window.location.pathname}${window.location.search}`;
  window.history.replaceState(window.history.state, document.title, cleanUrl);
}

export function clearKeycloakCallbackStorage() {
  Object.keys(localStorage)
    .filter((key) => key.startsWith('kc-callback-'))
    .forEach((key) => localStorage.removeItem(key));
}

/**
 * Clear OAuth params from the browser URL. Use window.location.hash only —
 * Vue Router's to.hash can remain stale after replaceState.
 */
export function resolveKeycloakCallbackHash(next) {
  if (!hasKeycloakCallbackHash()) {
    next();
    return;
  }

  clearKeycloakCallbackHash();
  next();
}
